import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  computed,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { BadgeComponent } from '../badge/badge.component';
import { IconComponent } from '../icon/icon.component';

export type NavItemLayout = 'default' | 'compact';

@Component({
  selector: 'ps-nav-item',
  standalone: true,
  imports: [RouterLink, BadgeComponent, IconComponent],
  templateUrl: './nav-item.component.html',
  styleUrl: './nav-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemComponent {
  public readonly icon = input.required<string>();

  public readonly badgeLabel = input<string>('');
  public readonly href = input<string>('');
  public readonly active = input<boolean>(false);
  public readonly disabled = input<boolean>(false);
  public readonly layout = input<NavItemLayout>('default');

  public readonly clicked = output<void>();

  protected readonly isCompact = computed<boolean>(
    () => this.layout() === 'compact',
  );
  protected readonly hasBadge = computed<boolean>(() => !!this.badgeLabel());
  protected readonly itemClasses = computed<string[]>(() => {
    const classes = ['ps-nav-item'];
    if (this.active()) classes.push('ps-nav-item-active');
    if (this.disabled()) classes.push('ps-nav-item-disabled');
    if (this.isCompact()) classes.push('ps-nav-item-collapsed');
    return classes;
  });

  protected onClick(event: Event): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }
    this.clicked.emit();
  }
}
